import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LogLevel, LoggerAbstractService } from 'bqx-logging';
import { NGXLogger } from 'ngx-logger';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { IChoice } from 'src/app/models/application-form/application-form.model';
import { FormGroupStringType } from 'src/app/models/shared/shared-types';
import { InputFocusAbstractService } from 'src/app/services/input-focus/input-focus.abstract.service';

@Component({
  selector: 'appform-dropdown-input',
  templateUrl: './dropdown-input.component.html',
  styleUrls: ['./dropdown-input.component.css']
})
export class DropdownInputComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() question_id: string;
  @Input() answer_id: string;
  @Input() code: string;
  @Input() fieldType: string;
  @Input() text: string;
  @Input() label: string;
  @Input() error_text: string;
  @Input() help_text: string;
  @Input() required: boolean;
  @Input() placeholder: string;
  @Input() choices: IChoice[];
  @Input() multiple: boolean;
  @Input() useAlias: boolean;
  @Input() choice_id: string;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onControlValueChanges = new EventEmitter<any>();
  @ViewChild('input') input: ElementRef<any>;
  @Input() invalid: boolean;
  @Input() hide_label: boolean;
  @Input() readOnly: boolean;
  private _formcontrolUnsub = new Subject<void>();

  get displayHelpText(): boolean {
    return this.help_text ? true : false;
  }
  public paramFormGroup: FormGroup<FormGroupStringType>;
  public inputControl: FormControl<string>;

  get isInvalid(): boolean {
    this.invalid = this.inputControl.invalid && this.inputControl.touched;
    return this.invalid;
  }

  constructor(
    private inputFocusService: InputFocusAbstractService,
    private loggerService: LoggerAbstractService,
    private logger: NGXLogger
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.choice_id && this.choice_id && this.inputControl) {
      this.inputControl.setValue(this.choice_id);
    }
  }

  ngAfterViewInit(): void {
    this.inputFocusService.emitAgentInputIsSet(this.input);
    // This forces validation for prefilled fields
    if (this.inputControl?.value) {
      this.inputControl.markAsDirty();
      this.inputControl.markAllAsTouched();
    }
  }

  ngOnInit(): void {
    this.initControlGroup();
  }

  private initControlGroup() {
    const formControlsGroup: FormGroupStringType = {};
    this.paramFormGroup = new FormGroup<FormGroupStringType>(formControlsGroup);
    this.inputControl = new FormControl<string>(null, this.required ? [Validators.required] : null);
    this.inputControl.setValue(this.choice_id);
    this.paramFormGroup.addControl(this.question_id, this.inputControl);
    this.inputControl.valueChanges
      .pipe(
        debounceTime(300), //had to added debounceTime to avoid Redux Async Error from SDK. Will Re-evaluate after discussing with BP.
        takeUntil(this._formcontrolUnsub)
      )
      .subscribe(
        (value: any) => {
          const event = {
            type: 'onControlValueChanges',
            data: {
              question_id: this.question_id,
              answer_id: this.answer_id,
              code: this.code,
              field_type: this.fieldType,
              choice_id: value,
              invalid: this.isInvalid
            }
          };
          this.onControlValueChanges.emit(event);
        },
        (err: string) => {
          this.loggerService.postLogData(LogLevel.Error, 'dropdown-input: initControlGroup', err, '')
          this._formcontrolUnsub.next();
          this._formcontrolUnsub.complete();
        }
      );
  }

  public choiceText(choice: IChoice): string {
    if (this.useAlias) {
      return choice.alias;
    } else {
      return choice.value;
    }
  }

  public getAriaLabel() {
    let labelBuilder = this.label;
    if (this.isInvalid) {
      labelBuilder += this.error_text;
    }
    return labelBuilder;
  }

  public getCurrentChoice(): string {
    let currentChoice = null;
    this.choices.forEach((choice) => {
      if (choice.id == this.choice_id) {
        currentChoice = choice;
      }
    });
    return currentChoice == null ? '' : currentChoice.value;
  }
}
